import React from 'react';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';
import {
	ContextualAnalyticsData,
	SCREEN,
	FireScreenAnalytics,
} from '@atlassian/jira-product-analytics-bridge';
import { JsmPageInteractiveEvent } from '@atlassian/jira-servicedesk-common/src/utils/browser-metric/index.tsx';
import { GenericError as ErrorView } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/errors/index.tsx';
import { SpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/main.tsx';
import { GlobalPageLoadExperience } from '@atlassian/ufo';
import { useMetricResource } from '../controllers/metric-resource';
import { SlaSettingsAppMain } from './main';

export const SlaSettingsApp = () => {
	const [{ loading, error, data }] = useMetricResource();

	if (error) {
		GlobalPageLoadExperience.failure({ force: true });
		return <ErrorView />;
	}

	if (loading === true || !data) {
		return <Spinner />;
	}

	return (
		<>
			<ContextualAnalyticsData sourceName="jsdSlaSettings" sourceType={SCREEN}>
				<FireScreenAnalytics />
				<SlaSettingsAppMain source={data} />
				<SpaStatePageReady />
			</ContextualAnalyticsData>
			<JsmPageInteractiveEvent />
		</>
	);
};
